module.exports = "img {\n  width: 100%;\n  height: auto;\n}\n"